import React from 'react';

import classes from './ProductType.module.css';


import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';

function ProductType(props){

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
      
    return(
        <div className={classes.box}>
            <hr className={classes.smallhr}></hr>
            <h6>Gender: {capitalizeFirstLetter(props.product.data.gender)}</h6>
            <hr className={classes.smallhr}></hr>
            <h6>Occasion: {props.product.data.occasion}</h6>
            <hr className={classes.smallhr}></hr>
            <h6>Seasons: {props.product.data.season}</h6>
            <hr className={classes.smallhr}></hr>
            
           
         
      
       
         
      </div>
    )
}


export default ProductType;   